export const OnCreateBorder = (createBorderData: any) => {
    return {
      type: 'onCreateBorder',
      createBorderData: [... createBorderData],
    }
  }
  